export interface Transaction {
  id: string
  date: string
  merchant: string
  category: string
  amount: number
  type: 'debit' | 'credit'
  icon: string
}

export interface BudgetCategory {
  id: string
  name: string
  icon: string
  spent: number
  limit: number
  color: string
}

export interface Investment {
  id: string
  symbol: string
  name: string
  shares: number
  price: number
  change: number
  changePercent: number
  value: number
  type: 'stock' | 'etf' | 'crypto'
}

export interface Goal {
  id: string
  name: string
  emoji: string
  targetAmount: number
  currentAmount: number
  deadline: string
  color: string
  monthlyContribution: number
}

export interface CreditFactor {
  name: string
  score: number
  impact: 'high' | 'medium' | 'low'
  description: string
}

export const transactions: Transaction[] = [
  {
    id: '1',
    date: '2026-02-20',
    merchant: 'Whole Foods Market',
    category: 'Food & Dining',
    amount: -87.43,
    type: 'debit',
    icon: '🛒',
  },
  {
    id: '2',
    date: '2026-02-20',
    merchant: 'Direct Deposit - Employer',
    category: 'Income',
    amount: 3250.0,
    type: 'credit',
    icon: '💼',
  },
  {
    id: '3',
    date: '2026-02-19',
    merchant: 'Netflix',
    category: 'Entertainment',
    amount: -15.99,
    type: 'debit',
    icon: '🎬',
  },
  {
    id: '4',
    date: '2026-02-19',
    merchant: 'Shell Gas Station',
    category: 'Transport',
    amount: -52.1,
    type: 'debit',
    icon: '⛽',
  },
  {
    id: '5',
    date: '2026-02-18',
    merchant: 'Starbucks',
    category: 'Food & Dining',
    amount: -6.75,
    type: 'debit',
    icon: '☕',
  },
  {
    id: '6',
    date: '2026-02-18',
    merchant: 'Amazon',
    category: 'Shopping',
    amount: -134.99,
    type: 'debit',
    icon: '📦',
  },
  {
    id: '7',
    date: '2026-02-17',
    merchant: 'CVS Pharmacy',
    category: 'Healthcare',
    amount: -23.5,
    type: 'debit',
    icon: '💊',
  },
  {
    id: '8',
    date: '2026-02-17',
    merchant: 'Uber',
    category: 'Transport',
    amount: -18.4,
    type: 'debit',
    icon: '🚗',
  },
  {
    id: '9',
    date: '2026-02-16',
    merchant: 'Spotify',
    category: 'Entertainment',
    amount: -9.99,
    type: 'debit',
    icon: '🎵',
  },
  {
    id: '10',
    date: '2026-02-16',
    merchant: "Trader Joe's",
    category: 'Food & Dining',
    amount: -64.2,
    type: 'debit',
    icon: '🛒',
  },
  {
    id: '11',
    date: '2026-02-15',
    merchant: 'Electric Bill - ConEd',
    category: 'Bills & Utilities',
    amount: -142.0,
    type: 'debit',
    icon: '⚡',
  },
  {
    id: '12',
    date: '2026-02-15',
    merchant: 'Freelance Payment',
    category: 'Income',
    amount: 850.0,
    type: 'credit',
    icon: '💻',
  },
  {
    id: '13',
    date: '2026-02-14',
    merchant: 'Restaurant - Nobu',
    category: 'Food & Dining',
    amount: -210.0,
    type: 'debit',
    icon: '🍽️',
  },
  {
    id: '14',
    date: '2026-02-14',
    merchant: 'Flowers - 1-800-Flowers',
    category: 'Shopping',
    amount: -65.0,
    type: 'debit',
    icon: '💐',
  },
  {
    id: '15',
    date: '2026-02-13',
    merchant: 'Planet Fitness',
    category: 'Healthcare',
    amount: -24.99,
    type: 'debit',
    icon: '🏋️',
  },
  {
    id: '16',
    date: '2026-02-13',
    merchant: 'Target',
    category: 'Shopping',
    amount: -89.34,
    type: 'debit',
    icon: '🎯',
  },
  {
    id: '17',
    date: '2026-02-12',
    merchant: 'Internet - Comcast',
    category: 'Bills & Utilities',
    amount: -79.99,
    type: 'debit',
    icon: '📡',
  },
  {
    id: '18',
    date: '2026-02-12',
    merchant: 'Lyft',
    category: 'Transport',
    amount: -14.2,
    type: 'debit',
    icon: '🚕',
  },
  {
    id: '19',
    date: '2026-02-11',
    merchant: 'Apple App Store',
    category: 'Entertainment',
    amount: -4.99,
    type: 'debit',
    icon: '📱',
  },
  {
    id: '20',
    date: '2026-02-11',
    merchant: 'Chipotle',
    category: 'Food & Dining',
    amount: -13.45,
    type: 'debit',
    icon: '🌯',
  },
  {
    id: '21',
    date: '2026-02-10',
    merchant: 'Dividend - AAPL',
    category: 'Income',
    amount: 42.5,
    type: 'credit',
    icon: '📈',
  },
  {
    id: '22',
    date: '2026-02-10',
    merchant: 'Walgreens',
    category: 'Healthcare',
    amount: -31.2,
    type: 'debit',
    icon: '💊',
  },
  {
    id: '23',
    date: '2026-02-09',
    merchant: 'H&M',
    category: 'Shopping',
    amount: -78.0,
    type: 'debit',
    icon: '👕',
  },
  {
    id: '24',
    date: '2026-02-09',
    merchant: 'Subway',
    category: 'Food & Dining',
    amount: -9.5,
    type: 'debit',
    icon: '🥪',
  },
  {
    id: '25',
    date: '2026-02-08',
    merchant: 'Parking - NYC',
    category: 'Transport',
    amount: -35.0,
    type: 'debit',
    icon: '🅿️',
  },
  {
    id: '26',
    date: '2026-02-08',
    merchant: 'Disney+',
    category: 'Entertainment',
    amount: -13.99,
    type: 'debit',
    icon: '🎠',
  },
  {
    id: '27',
    date: '2026-02-07',
    merchant: 'Whole Foods Market',
    category: 'Food & Dining',
    amount: -92.1,
    type: 'debit',
    icon: '🛒',
  },
  {
    id: '28',
    date: '2026-02-07',
    merchant: 'Phone Bill - Verizon',
    category: 'Bills & Utilities',
    amount: -85.0,
    type: 'debit',
    icon: '📱',
  },
  {
    id: '29',
    date: '2026-02-06',
    merchant: 'IKEA',
    category: 'Shopping',
    amount: -245.6,
    type: 'debit',
    icon: '🪑',
  },
  {
    id: '30',
    date: '2026-02-06',
    merchant: 'Cashback Reward',
    category: 'Income',
    amount: 28.75,
    type: 'credit',
    icon: '💳',
  },
  {
    id: '31',
    date: '2026-02-05',
    merchant: "McDonald's",
    category: 'Food & Dining',
    amount: -11.2,
    type: 'debit',
    icon: '🍔',
  },
  {
    id: '32',
    date: '2026-02-05',
    merchant: 'Gym Supplement Store',
    category: 'Healthcare',
    amount: -54.99,
    type: 'debit',
    icon: '💪',
  },
  {
    id: '33',
    date: '2026-02-04',
    merchant: 'Airbnb',
    category: 'Travel',
    amount: -320.0,
    type: 'debit',
    icon: '🏠',
  },
  {
    id: '34',
    date: '2026-02-04',
    merchant: 'Delta Airlines',
    category: 'Travel',
    amount: -285.0,
    type: 'debit',
    icon: '✈️',
  },
  {
    id: '35',
    date: '2026-02-03',
    merchant: 'Costco',
    category: 'Food & Dining',
    amount: -156.8,
    type: 'debit',
    icon: '🛒',
  },
  {
    id: '36',
    date: '2026-02-03',
    merchant: 'Venmo - Friend',
    category: 'Income',
    amount: 50.0,
    type: 'credit',
    icon: '💸',
  },
  {
    id: '37',
    date: '2026-02-02',
    merchant: 'Steam Games',
    category: 'Entertainment',
    amount: -29.99,
    type: 'debit',
    icon: '🎮',
  },
  {
    id: '38',
    date: '2026-02-02',
    merchant: 'Dentist Office',
    category: 'Healthcare',
    amount: -150.0,
    type: 'debit',
    icon: '🦷',
  },
  {
    id: '39',
    date: '2026-02-01',
    merchant: 'Rent Payment',
    category: 'Bills & Utilities',
    amount: -2100.0,
    type: 'debit',
    icon: '🏠',
  },
  {
    id: '40',
    date: '2026-02-01',
    merchant: 'Direct Deposit - Employer',
    category: 'Income',
    amount: 3250.0,
    type: 'credit',
    icon: '💼',
  },
  {
    id: '41',
    date: '2026-01-31',
    merchant: 'Sushi Restaurant',
    category: 'Food & Dining',
    amount: -78.5,
    type: 'debit',
    icon: '🍣',
  },
  {
    id: '42',
    date: '2026-01-30',
    merchant: 'Nike Store',
    category: 'Shopping',
    amount: -129.0,
    type: 'debit',
    icon: '👟',
  },
  {
    id: '43',
    date: '2026-01-29',
    merchant: 'Gas - BP',
    category: 'Transport',
    amount: -48.3,
    type: 'debit',
    icon: '⛽',
  },
  {
    id: '44',
    date: '2026-01-28',
    merchant: 'Hulu',
    category: 'Entertainment',
    amount: -17.99,
    type: 'debit',
    icon: '📺',
  },
  {
    id: '45',
    date: '2026-01-27',
    merchant: 'Grocery Outlet',
    category: 'Food & Dining',
    amount: -43.2,
    type: 'debit',
    icon: '🛒',
  },
  {
    id: '46',
    date: '2026-01-26',
    merchant: 'Interest Income',
    category: 'Income',
    amount: 18.4,
    type: 'credit',
    icon: '🏦',
  },
  {
    id: '47',
    date: '2026-01-25',
    merchant: 'Best Buy',
    category: 'Shopping',
    amount: -199.99,
    type: 'debit',
    icon: '🖥️',
  },
  {
    id: '48',
    date: '2026-01-24',
    merchant: 'Uber Eats',
    category: 'Food & Dining',
    amount: -32.8,
    type: 'debit',
    icon: '🍕',
  },
  {
    id: '49',
    date: '2026-01-23',
    merchant: 'Car Insurance - Geico',
    category: 'Bills & Utilities',
    amount: -142.0,
    type: 'debit',
    icon: '🚗',
  },
  {
    id: '50',
    date: '2026-01-22',
    merchant: 'Bookstore',
    category: 'Entertainment',
    amount: -24.99,
    type: 'debit',
    icon: '📚',
  },
]

export const budgetCategories: BudgetCategory[] = [
  {
    id: '1',
    name: 'Food & Dining',
    icon: '🍽️',
    spent: 751.93,
    limit: 900,
    color: '#F59E0B',
  },
  {
    id: '2',
    name: 'Transport',
    icon: '🚗',
    spent: 167.0,
    limit: 300,
    color: '#3B82F6',
  },
  {
    id: '3',
    name: 'Shopping',
    icon: '🛍️',
    spent: 841.93,
    limit: 800,
    color: '#EC4899',
  },
  {
    id: '4',
    name: 'Entertainment',
    icon: '🎬',
    spent: 117.93,
    limit: 200,
    color: '#8B5CF6',
  },
  {
    id: '5',
    name: 'Bills & Utilities',
    icon: '⚡',
    spent: 2548.99,
    limit: 2600,
    color: '#EF4444',
  },
  {
    id: '6',
    name: 'Healthcare',
    icon: '💊',
    spent: 284.68,
    limit: 400,
    color: '#10B981',
  },
  {
    id: '7',
    name: 'Travel',
    icon: '✈️',
    spent: 605.0,
    limit: 500,
    color: '#06B6D4',
  },
]

export const investments: Investment[] = [
  {
    id: '1',
    symbol: 'AAPL',
    name: 'Apple Inc.',
    shares: 15,
    price: 189.84,
    change: 2.34,
    changePercent: 1.25,
    value: 2847.6,
    type: 'stock',
  },
  {
    id: '2',
    symbol: 'MSFT',
    name: 'Microsoft Corp.',
    shares: 8,
    price: 415.32,
    change: -1.2,
    changePercent: -0.29,
    value: 3322.56,
    type: 'stock',
  },
  {
    id: '3',
    symbol: 'GOOGL',
    name: 'Alphabet Inc.',
    shares: 5,
    price: 175.98,
    change: 3.45,
    changePercent: 2.0,
    value: 879.9,
    type: 'stock',
  },
  {
    id: '4',
    symbol: 'VTI',
    name: 'Vanguard Total Market ETF',
    shares: 25,
    price: 248.15,
    change: 1.85,
    changePercent: 0.75,
    value: 6203.75,
    type: 'etf',
  },
  {
    id: '5',
    symbol: 'VOO',
    name: 'Vanguard S&P 500 ETF',
    shares: 12,
    price: 512.4,
    change: 2.1,
    changePercent: 0.41,
    value: 6148.8,
    type: 'etf',
  },
  {
    id: '6',
    symbol: 'BTC',
    name: 'Bitcoin',
    shares: 0.35,
    price: 98420.0,
    change: 1250.0,
    changePercent: 1.29,
    value: 34447.0,
    type: 'crypto',
  },
  {
    id: '7',
    symbol: 'ETH',
    name: 'Ethereum',
    shares: 2.5,
    price: 3180.0,
    change: -45.0,
    changePercent: -1.4,
    value: 7950.0,
    type: 'crypto',
  },
]

export const goals: Goal[] = [
  {
    id: '1',
    name: 'Emergency Fund',
    emoji: '🛡️',
    targetAmount: 10000,
    currentAmount: 6500,
    deadline: '2026-06-30',
    color: '#1566FF',
    monthlyContribution: 500,
  },
  {
    id: '2',
    name: 'Vacation to Japan',
    emoji: '✈️',
    targetAmount: 5000,
    currentAmount: 1850,
    deadline: '2026-12-01',
    color: '#39E75F',
    monthlyContribution: 300,
  },
  {
    id: '3',
    name: 'House Down Payment',
    emoji: '🏠',
    targetAmount: 50000,
    currentAmount: 14200,
    deadline: '2028-01-01',
    color: '#F59E0B',
    monthlyContribution: 1000,
  },
  {
    id: '4',
    name: 'New MacBook Pro',
    emoji: '💻',
    targetAmount: 3500,
    currentAmount: 2100,
    deadline: '2026-04-01',
    color: '#8B5CF6',
    monthlyContribution: 350,
  },
]

export const creditFactors: CreditFactor[] = [
  {
    name: 'Payment History',
    score: 98,
    impact: 'high',
    description: "You've made all payments on time for the past 24 months.",
  },
  {
    name: 'Credit Utilization',
    score: 72,
    impact: 'high',
    description:
      'Using 28% of available credit. Keep below 30% for best results.',
  },
  {
    name: 'Credit Age',
    score: 65,
    impact: 'medium',
    description: 'Average account age is 4.2 years. Older is better.',
  },
  {
    name: 'Account Mix',
    score: 80,
    impact: 'medium',
    description: 'Good mix of credit cards, auto loan, and mortgage.',
  },
  {
    name: 'New Inquiries',
    score: 90,
    impact: 'low',
    description: 'Only 1 hard inquiry in the past 12 months.',
  },
]

export const creditScoreHistory = [
  { month: 'Mar', score: 698 },
  { month: 'Apr', score: 705 },
  { month: 'May', score: 712 },
  { month: 'Jun', score: 708 },
  { month: 'Jul', score: 718 },
  { month: 'Aug', score: 725 },
  { month: 'Sep', score: 730 },
  { month: 'Oct', score: 728 },
  { month: 'Nov', score: 735 },
  { month: 'Dec', score: 738 },
  { month: 'Jan', score: 740 },
  { month: 'Feb', score: 742 },
]

export const monthlySpending = [
  { month: 'Sep', income: 7200, expenses: 4800, savings: 2400 },
  { month: 'Oct', income: 7400, expenses: 5100, savings: 2300 },
  { month: 'Nov', income: 7200, expenses: 5800, savings: 1400 },
  { month: 'Dec', income: 8100, expenses: 6900, savings: 1200 },
  { month: 'Jan', income: 7350, expenses: 4600, savings: 2750 },
  { month: 'Feb', income: 7489, expenses: 5317, savings: 2172 },
]

export const portfolioHistory = {
  '1W': [
    { date: 'Feb 14', value: 59200 },
    { date: 'Feb 15', value: 59800 },
    { date: 'Feb 16', value: 59400 },
    { date: 'Feb 17', value: 60100 },
    { date: 'Feb 18', value: 60500 },
    { date: 'Feb 19', value: 61200 },
    { date: 'Feb 20', value: 61799 },
  ],
  '1M': [
    { date: 'Jan 20', value: 57000 },
    { date: 'Jan 27', value: 58200 },
    { date: 'Feb 3', value: 59100 },
    { date: 'Feb 10', value: 60300 },
    { date: 'Feb 17', value: 60500 },
    { date: 'Feb 20', value: 61799 },
  ],
  '3M': [
    { date: 'Nov', value: 52000 },
    { date: 'Dec', value: 54500 },
    { date: 'Jan', value: 57800 },
    { date: 'Feb', value: 61799 },
  ],
  '1Y': [
    { date: 'Mar', value: 44000 },
    { date: 'May', value: 47000 },
    { date: 'Jul', value: 50000 },
    { date: 'Sep', value: 53000 },
    { date: 'Nov', value: 55000 },
    { date: 'Feb', value: 61799 },
  ],
  ALL: [
    { date: '2023', value: 28000 },
    { date: '2024', value: 38000 },
    { date: '2025', value: 52000 },
    { date: '2026', value: 61799 },
  ],
}

export const netWorthHistory = [
  { month: 'Sep', netWorth: 68000 },
  { month: 'Oct', netWorth: 70200 },
  { month: 'Nov', netWorth: 71500 },
  { month: 'Dec', netWorth: 72100 },
  { month: 'Jan', netWorth: 74800 },
  { month: 'Feb', netWorth: 76420 },
]

export const spendingByCategory = [
  { name: 'Bills', value: 2549, color: '#EF4444' },
  { name: 'Food', value: 752, color: '#F59E0B' },
  { name: 'Shopping', value: 842, color: '#EC4899' },
  { name: 'Travel', value: 605, color: '#06B6D4' },
  { name: 'Healthcare', value: 285, color: '#10B981' },
  { name: 'Transport', value: 167, color: '#3B82F6' },
  { name: 'Entertainment', value: 118, color: '#8B5CF6' },
]
